import { TableCell } from '@mui/material';
import React, { useMemo } from 'react';
import { format, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
export function CustomTableCell({ timestamp }) {
 const formattedDate = useMemo(() => {
    if (!timestamp) return '—';

    try {
      const utcDate = parseISO(timestamp);
      if (isNaN(utcDate.getTime())) return 'Invalid Date';

      const estDate = toZonedTime(utcDate, 'America/New_York');
      return format(estDate, 'dd-MM-yyyy hh:mm:ss a');
    } catch (error) {
      return 'Invalid Date';
    }
  }, [timestamp]);

  return <TableCell>{formattedDate}</TableCell>;
}

